import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import TaskManagement_Ordinary_001 from './img/TaskManagement_Ordinary_001.png'

export default class OrdinaryTaskManament extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">普通用户没有任务管理的权限</div>
        <img src={TaskManagement_Ordinary_001} className="main-window-img"></img>
      </div>
    )
  }
}
